<template>
  <div class="contentBox">
    <div class="loginBox">
      <div class="title">
        <!-- <div class="logoBox">
          <div>
            <img
              src="../assets/MFA/ic_logo_big.png"
              height="30px"
              width="30px"
            />
          </div>
        </div> -->
        <div class="titleBox">
          <h2>{{ $t("googleLogin.title") }}</h2>
        </div>
      </div>
      <div class="codeBox">
        <el-input
          v-model="verificationCode"
          :placeholder="$t('google.mfa')"
          @keyup.enter.native="googleLogin()"
          style="margin-bottom: 15px"
        ></el-input>
        <span>{{ $t("googleLogin.inputPrompt") }}</span>
      </div>

      <el-button type="primary" @click="googleLogin()" style="width: 100%">
        {{ $t("button.nextStep") }}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      verificationCode: "",
      username: "",
    };
  },
  created() {
    this.$route.params.username
      ? (this.username = this.$route.params.username)
      : (this.username = localStorage.getItem("as-username"));
  },
  methods: {
    googleLogin() {
      if (this.verificationCode && this.verificationCode.length == 6) {
        let submitInfo = {
          username: this.username,
          code: this.verificationCode,
        };
        return new Promise((resolve, reject) => {
          this.$httpList
            .googleLogin(submitInfo)
            .then((res) => {
              console.log(res);
              if (res.resultCode == 1001) {
                this.$router.push({
                  name: "Home",
                });
              }
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        });
      } else {
        this.$notify.warning({
          message: this.$t("googleLogin.inputBoxPrompt"),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contentBox {
  display: flex;
  justify-content: center;
  // align-items: center;
  height: 100%;
  background-color: #f3f3f4;
  align-items: center;

  .loginBox {
    height: fit-content;
    width: 25vw;
    background-color: white;
    border-radius: 20px;

    display: flex;
    flex-direction: column;
    padding: 25px;
    .title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .logoBox {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #015ac5;
        width: 40px;
        margin-right: 10px;
      }
    }
    .el-input {
      margin-bottom: 0px !important;
    }
    .codeBox {
      margin-bottom: 20px;
    }
  }
}
</style>
